import moment from "moment";
/**
 * 日期组件options 里的shortcuts
 * @param type
 * eq:包含  lq:不包含
 * @param list
 *          am:上午
 *          pm:下午
 *          day:今天
 *          fday:昨天
 *          week:本周
 *          fweek:上周
 *          fweekday:上周今天
 *          month:本月
 *          fmonth:上月
 *          fmonthday:上月今天
 *          year:今年
 *          fyear:去年
 *          yearf:今前半年
 *          yearl:今后半年
 *          fyearday:去年今天
 * @returns {*[]}
 */
function shortcuts(type='eq',list){
    let reslist=[];
    if(list)
    {
        if(typeof list=='object')
        {
            reslist=list;
        }
        else
        {
            if(list==1)
            {
                reslist=['am','pm','fyearday','fmonthday','fweekday','yearf','yearl','fweek','fmonth','fyear'];
            }
            else if(list==2)
            {
                reslist=['am','pm','fyearday','fmonthday','fweekday'];
            }
            else if(list==3)
            {
                reslist=['am','pm'];
            }
            else if(list==4)
            {
                reslist=['fyearday','fmonthday','fweekday','yearf','yearl','fweek','fmonth','fyear'];
            }

            // else if(list==9)
            // {
            //     reslist=['1day','2day','3day','5day','7day','10day','15day','1monthday'];
            // }
        }
    }
    const deflist=[
        {
            text:'AM',
            code:'am',
            onClick(picker) {
                const start=moment().format('yyyy-MM-DD 00:00:00');
                const end=moment().format('yyyy-MM-DD 11:59:59');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text:'PM',
            code:'pm',
            onClick(picker) {
                const start=moment().format('yyyy-MM-DD 12:00:00');
                const end=moment().format('yyyy-MM-DD 23:59:59');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '今天',
            code:'day',
            onClick(picker) {
                const start=moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                const end=moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '昨天',
            code:'fday',
            onClick(picker) {
                const start=moment().subtract('1','d').startOf('day').format('YYYY-MM-DD HH:mm:ss');
                const end=moment().subtract('1','d').endOf('day').format('YYYY-MM-DD HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '本周',
            code:'week',
            onClick(picker) {
                const start=moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
                const end=moment().endOf('week').format('YYYY-MM-DD HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '上周今天',
            code:'fweekday',
            onClick(picker) {
                const start=moment().subtract('1','week').startOf('day').format('YYYY-MM-DD HH:mm:ss');
                const end=moment().subtract('1','week').endOf('day').format('YYYY-MM-DD HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '上周',
            code:'fweek',
            onClick(picker) {
                const start=moment().subtract('1','week').startOf('week').format('YYYY-MM-DD HH:mm:ss');
                const end=moment().subtract('1','week').endOf('week').format('YYYY-MM-DD HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '本月',
            code:'month',
            onClick(picker) {
                const start=moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
                const end=moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '上月今天',
            code:'fmonthday',
            onClick(picker) {
                const start=moment().subtract('1','month').startOf('day').format('YYYY-MM-DD HH:mm:ss');
                const end=moment().subtract('1','month').endOf('day').format('YYYY-MM-DD HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '上月',
            code:'fmonth',
            onClick(picker) {
                const start=moment().subtract('1','month').startOf('month').format('YYYY-MM-DD HH:mm:ss');
                const end=moment().subtract('1','month').endOf('month').format('YYYY-MM-DD HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '今前半年',
            code:'yearf',
            onClick(picker) {
                const start=moment().startOf('year').format('YYYY-MM-DD HH:mm:ss');
                const end=moment().endOf('year').format('YYYY-06-30 HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '今后半年',
            code:'yearl',
            onClick(picker) {
                const start=moment().startOf('year').format('YYYY-07-01 HH:mm:ss');
                const end=moment().endOf('year').format('YYYY-MM-DD HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '今年',
            code:'year',
            onClick(picker) {
                const start=moment().startOf('year').format('YYYY-MM-DD HH:mm:ss');
                const end=moment().endOf('year').format('YYYY-MM-DD HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '去年今天',
            code:'fyearday',
            onClick(picker) {
                const start=moment().subtract('1','year').startOf('day').format('YYYY-MM-DD HH:mm:ss');
                const end=moment().subtract('1','year').endOf('day').format('YYYY-MM-DD HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '去年',
            code:'fyear',
            onClick(picker) {
                const start=moment().subtract('1','year').startOf('year').format('YYYY-MM-DD HH:mm:ss');
                const end=moment().subtract('1','year').endOf('year').format('YYYY-MM-DD HH:mm:ss');
                picker.$emit('pick', [start, end]);
            }
        },
        // {
        //     text: '1天',
        //     code:'1day',
        //     onClick(picker) {
        //         const start=moment().add('1','d').startOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         const end=moment().add('1','d').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         picker.$emit('pick', [start, end]);
        //     }
        // },
        // {
        //     text: '2天',
        //     code:'2day',
        //     onClick(picker) {
        //         const start=moment().add('1','d').startOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         const end=moment().add('2','d').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         picker.$emit('pick', [start, end]);
        //     }
        // },
        // {
        //     text: '3天',
        //     code:'3day',
        //     onClick(picker) {
        //         const start=moment().add('1','d').startOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         const end=moment().add('3','d').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         picker.$emit('pick', [start, end]);
        //     }
        // },
        // {
        //     text: '5天',
        //     code:'5day',
        //     onClick(picker) {
        //         const start=moment().add('1','d').startOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         const end=moment().add('5','d').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         picker.$emit('pick', [start, end]);
        //     }
        // },
        // {
        //     text: '7天',
        //     code:'7day',
        //     onClick(picker) {
        //         const start=moment().add('1','d').startOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         const end=moment().add('7','d').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         picker.$emit('pick', [start, end]);
        //     }
        // },
        // {
        //     text: '10天',
        //     code:'10day',
        //     onClick(picker) {
        //         const start=moment().add('1','d').startOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         const end=moment().add('10','d').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         picker.$emit('pick', [start, end]);
        //     }
        // },
        // {
        //     text: '15天',
        //     code:'15day',
        //     onClick(picker) {
        //         const start=moment().add('1','d').startOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         const end=moment().add('15','d').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         picker.$emit('pick', [start, end]);
        //     }
        // },
        // {
        //     text: '一个月',
        //     code:'1monthday',
        //     onClick(picker) {
        //         const start=moment().add('1','d').startOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         const end=moment().add('1','month').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        //         picker.$emit('pick', [start, end]);
        //     }
        // }
    ];
    let retList=[];
    if(type=='lq')
    {
        if(reslist.length)
        {
            retList=deflist.filter(item=>!reslist.includes(item.code));
        }
        else
        {
            retList=[]
        }
    }
    else
    {
        if(reslist.length) {
            retList = deflist.filter(item => reslist.includes(item.code));
        }
        else
        {
            retList=deflist;
        }

    }
    return retList
}
export default {shortcuts};